import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Import your new Analytics component
import Analytics from "./Analytics"; // Adjust the path if you saved it elsewhere
import AnalyticsDashboard from "./pages/AnalyticsDashboard";


import Header1 from "./Components/HomePage/Header1.js";
import Adminuser from "./Components/HomePage/Loginpage.js";
import Welcome from "./Components/MENU/HRMS/Welcome";
import Productmasterimg from "./Components/MENU/PRODUCT/Product/Productmasterimg.js";
import Sidebar from "./Components/MENU/Sidebar.js";
import ProductGroup from "./Components/MENU/PRODUCT/Pruduct_group/ProductGroup";
import ProductMaster from "./Components/MENU/PRODUCT/Product/Product.js";
import Features from "./Components/MENU/PRODUCT/ComponentList/Features";
import FeaturesMapping from "./Components/MENU/PRODUCT/ComponentsMapping/FeaturesMapping";
import ProductCard from "./Components/ProductCard";
import Shopping from "./Components/Shopping";
import Fetch from "./Components/Fetch";
import Banner from "./Components/Demo_1";
import Category from "./Components/Demo_2";
import Demo_3 from "./Components/Demo_3";
import Demo_4 from "./Components/Demo_4.js";
import ProductGroupImg from "./Components/MENU/PRODUCT/Pruduct_group/ProductGroupImg";
import Usertype from "./Components/MENU/HRMS/Usertype";
import UserTypePrivileges from "./Components/MENU/HRMS/UserTypePrivileges";
import ProtectedRoute from "./Components/ProtectedRoute";
import Cart from "./Cart/Cart.jsx";
import Manageproduct from "./Manageproducts/Manageproduct";
// import PaymentButton, {} from './Razorpay/PaymentButton'
import Step4 from "./Components/DynamicComp/Step4";
import FetchPaymentDetails from "./Checking/FetchPaymentDetails.js";
import CheckoutForm from "./Checking/CheckoutForm1.jsx";
import Layout from "./Components/DynamicComp/Layout.jsx";
import Coupons from "./Coupons/Coupons.jsx";
import ManageOrders from "./Orders/ManageOrders.jsx";

import { OrderProvider } from "./context/OrderContext.js";
import OrderDetails from "./pages/OrderDetails.js";
import MyOrders from "./pages/MyOrders.js";
import OrderTracking from "./pages/OrderTracking.js";
import Settings from "./Admin/Settings.js";
import ReturnOrderModal from "./Components/ReturnOrderModal.js";
import ReturnedOrders from "./Admin/ReturnedOrders.js";
import ProductCategory from "./Components/MENU/PRODUCT/Pruduct_group/ProductCategory.js";
import ErrorBoundary from "./Setting/ErrorBoundary.js";
import ThemePage from "./Components/ThemePage.js";
import WishproductsCards from "./Components/WishproductsCards.js";
import AffiliateUserLogin from "./Components/MENU/HRMS/personalInfo.jsx"; // AffiliateLogin Page
import AffiliateCampaign from "./Components/MENU/HRMS/affiliateCampaign.jsx";
import TermsandService from "./Components/MENU/HRMS/TermsandService.jsx";
import AffiliateLogin from "./Components/HomePage/AffiliateLogin.js";
import BatchManagement from "./Components/MENU/PRODUCT/Product/BatchManagement .js";
import BatchAuditViewer from "./Components/MENU/PRODUCT/Product/BatchAuditViewer.jsx";
import ProductBarcodePage from "./Components/MENU/PRODUCT/Product/ProductBarcodePage.jsx";

import AffiliateCampaignInvite from "./Components/MENU/HRMS/AffiliateCampaignInvite.jsx";
import PopupWrapper from "./Components/MENU/HRMS/PopupWrapper.jsx";
import PopupInvitePage from "./Components/MENU/HRMS/PopupInvitePage.jsx";
import PopupWrapperPage from "./Components/MENU/HRMS/PopupWrapperPage.jsx";
import PopupPage from "./Components/MENU/HRMS/PopupPage.jsx";
import Shipping from "./Components/Shipping.jsx";
import S_Partner_For from "./Components/S_Partner_For.jsx";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ForgotPassword from "./pages/ForgotPassword.jsx";
import ResetPassword from "./pages/ResetPassword.jsx";

import AccountMaster from "./Branch/AccountMaster.js";
import AccountType from "./Branch/AccountType.js";
import BranchMasterForm from "./Branch/BranchMasterForm .js";
import CompanyMasterForm from "./Branch/CompanyMasterForm.js";
import RegionMasterForm from "./Branch/RegionMasterForm.js";

function App() {
  useEffect(() => {
    // Load the GA script
    const script1 = document.createElement("script");
    script1.async = true;
    script1.src = "https://www.googletagmanager.com/gtag/js?id=G-2ELCGT2TFT";
    document.head.appendChild(script1);

    const script2 = document.createElement("script");
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-2ELCGT2TFT');
    `;
    document.head.appendChild(script2);
  }, []);

  const App = () => {};
  const [themeId, setThemeId] = useState(() => {
    const saved = localStorage.getItem("themeId");
    return saved ? Number(saved) : 1; // default to 1 if nothing in storage
  });
  useEffect(() => {
    if (themeId === 1) {
      document.body.className = "theme-1";
    } else if (themeId === 2) {
      document.body.className = "theme-2";
    } else if (themeId === 3) {
      document.body.className = "theme-3";
    } else if (themeId === 4) {
      document.body.className = "theme-4";
    }
  }, [themeId]);

  return (
    <Router>
      {/* Add the Analytics component here */}
      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
        theme="light"
      />
      <Analytics />
      <OrderProvider>
        {/* <ErrorBoundary> */}
        <Routes>
          {/* Public Route */}

          <Route path="/adminuser" element={<Adminuser />} />

          {/* Protected Routes */}
          {/* <Route
          path="/menu"
          element={
            <ProtectedRoute allowedRoles={["Admin", "Super Admin"]}>
              <Menu />
            </ProtectedRoute>
          }
        /> */}

          <Route
            path="/menu"
            element={
              <ProtectedRoute
                element={<Sidebar themeId={themeId} setThemeId={setThemeId} />}
              />
            }
          />

          {/* <Route
          path="/usertypeprivileges"
          element={
            <ProtectedRoute allowedRoles={["Admin", "Super Admin"]}>
              <UserTypePrivileges />
            </ProtectedRoute>
          }
        /> */}

          <Route
            path="/usertypeprivileges"
            element={
              <ProtectedRoute
                element={<UserTypePrivileges />}
                allowedUsertypes={["1"]}
              />
            }
          />
          <Route
            path="/features_mapping"
            element={
              <ProtectedRoute
                element={<FeaturesMapping />}
                allowedUsertypes={["1", "2"]}
              />
            }
          />

          {/* Additional Routes (optional) */}
          <Route element={<Layout />}>
            {/* <Route path="/" element={<Header1 />} /> */}

            <Route
              path=""
              element={
                window.location.hostname === "stage-sell.boltandbrook.com" ? (
                  <Adminuser />
                ) : (
                  <Header1 />
                )
              }
            />

            <Route path="/user" element={<Welcome />} />

            <Route path="/user" element={<Welcome />} />

            {/* <Route path="" element={<Myorder/>}/> */}
            <Route path="myorders" element={<MyOrders />} />
            <Route path="/orders/:orderId" element={<OrderDetails />} />
            <Route
              path="/order-tracking/:orderId"
              element={<OrderTracking />}
            />
            <Route path="settings" element={<Settings />} />
            <Route path="return" element={<ReturnOrderModal />} />
            <Route path="returnedorders" element={<ReturnedOrders />} />

            {/* <Route path="/cancel-order/:userId" element={<OrderCancel />} />/ */}
            <Route path="/productimg" element={<Productmasterimg />} />
            <Route path="/product" element={<ProductGroup />} />
            <Route path="/productgroupimg" element={<ProductGroupImg />} />
            <Route path="/product" element={<ProductMaster />} />
            <Route path="/features" element={<Features />} />
            <Route path="/product/:id" element={<Step4 type="Main Page" />} />
            <Route path="/shopping" element={<Shopping />} />
            <Route path="/fetch" element={<Fetch />} />
            <Route path="/banner" element={<Banner />} />
            <Route path="/category" element={<Category />} />
            <Route path="/demo3" element={<Demo_3 />} />
            <Route path="/usertype1" element={<Usertype />} />
            <Route path="/usertype2" element={<UserTypePrivileges />} />
            {/* Analytics Dashboard Route */}
            <Route
              path="/analytics-dashboard"
              element={<AnalyticsDashboard />}
            />
            <Route path="/cart" element={<Cart />} />
            <Route path="manageproduct" element={<Manageproduct />} />
            <Route path="/checkpayment" element={<FetchPaymentDetails />} />
            <Route path="/checkout" element={<CheckoutForm />} />
            <Route path="/coupons" element={<Coupons />} />
            <Route
              path="/checkout/:userid/:couponid"
              element={<CheckoutForm />}
            />
            <Route path="/manageorders" element={<ManageOrders />} />
            <Route path="/productcategory" element={<ProductCategory />} />
            <Route path="/ThemePage" element={<ThemePage />} />
            <Route path="/wishlist" element={<WishproductsCards />} />
            <Route
              path="/affiliateUserLogin"
              element={<AffiliateUserLogin />}
            />
            <Route path="/campaigns" element={<AffiliateCampaign />} />
            <Route path="/terms" element={<TermsandService />} />
            <Route path="/affiliatelogin" element={<AffiliateLogin />} />
            <Route path="/batch" element={<BatchManagement />} />
            <Route path="/batchhistory" element={<BatchAuditViewer />} />
            <Route path="/productBarcode" element={<ProductBarcodePage />} />
            <Route
              path="/affiliatecampaigninvite"
              element={<AffiliateCampaignInvite />}
            />
            <Route path="/campaignInvitepopup" element={<PopupWrapper />} />
            <Route path="/popupwrapper" element={<PopupInvitePage />} />
            <Route path="/popupwrapper" element={<PopupWrapperPage />} />

            <Route path="/popup" element={<PopupPage />} />
            <Route path="/Shipments" element={<Shipping />} />
            <Route path="/Shipments/AddPartners" element={<S_Partner_For />} />

            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />

            <Route path="/demo4" element={<Demo_4 />} />
            <Route path="/checkout/:userid" element={<CheckoutForm />} />
            <Route path="/checkout/order/:orderId" element={<CheckoutForm />} />

            <Route
              path="/Branch/CompanyMasterForm"
              element={<CompanyMasterForm />}
            />
            <Route
              path="/Branch/RegionMasterForm"
              element={<RegionMasterForm />}
            />
            <Route path="/Branch/AccountMaster" element={<AccountMaster />} />
            <Route path="/Branch/AccountType" element={<AccountType />} />
            <Route
              path="/Branch/BranchMasterForm"
              element={<BranchMasterForm />}
            />
          </Route>
        </Routes>
        {/* </ErrorBoundary> */}
      </OrderProvider>
    </Router>
  );
}

export default App;
